<template lang="pug">
.dialog-container
  download-excel(:data = "excelReport", :title='getExcelHeader')
    el-button.float-right(id="LedReport-downloadExcelButton", type='text', size="mini", :title='$t("Download excel file")')
      font-awesome-icon.medium-icon(icon="download")
  .row.header
    .cell.header.networkname {{ $t('Network') }}
      br
      el-input.input(id="LedReport-networkSearchInput", v-model="search['Device.Network.name']", size='mini', type='text', clearable)
    .cell.header.devicename {{ $t('Device') }}
      br
      el-input.input(id="LedReport-deviceSearchInput", v-model="search['Device.name']", size='mini', type='text', clearable)
    .cell.header.displayname {{ $t('Display') }}
      br
      el-input.input(id="LedReport-displaySearchInput", v-model="search['name']", size='mini', type='text', clearable)
    .cell.header.pitch {{ $t('Pitch') }}
      br
      el-input.input(id="LedReport-pitchSearchInput", v-model="search['LedPitch.name']", size='mini', type='text', clearable)
    .cell.header.widthpx {{ $t('Width px') }}
    .cell.header.heightpx {{ $t('Height px') }}
    .cell.header.widthpanels {{ $t('# of panels in width') }}
    .cell.header.heightpanels {{ $t('# of panels in height') }}
    .cell.header.widthmm {{ $t('Width mm') }}
    .cell.header.heightmm {{ $t('Height mm') }}
    .cell.header.areasqm {{ $t('Area sq. meters')}}
  .row(v-for='ledDisplay of report', :key='ledDisplay.id', :id="'LedReport-ledRow' + ledDisplay.id")
    .cell.networkname {{ ledDisplay.Device.Network.name }}
    .cell.devicename {{ ledDisplay.Device.name }}
    .cell.displayname {{ ledDisplay.name }}
    .cell.pitch {{ ledDisplay.LedPitch.name }}
    .cell.widthpx {{ ledDisplay.width }}
    .cell.heightpx {{ ledDisplay.height }}
    .cell.widthpanels {{ calculateWidthPanels(ledDisplay) }}
    .cell.heightpanels {{ calculateHeightPanels(ledDisplay) }}
    .cell.widthmm {{ calculateWidthmm(ledDisplay) }}
    .cell.heightmm {{ calculateHeightmm(ledDisplay) }}
    .cell.areasqm {{ calculateAreasqm(ledDisplay) }}
</template>

<script>

import Vue from 'vue'
import downloadExcel from 'vue-json-excel'
export default {
  props: [],
  components: {
    downloadExcel
  },
  async created () {
    await this.getLedDisplays()
  },
  data () {
    return {
      errors: {
      },
      ledDisplays: [],
      ledPitches: [],
      search: {}
    }
  },
  methods: {
    async getLedDisplays () {
      this.ledPitches = (await Vue.axios.get('ledpitch?populate=false')).data
      this.ledDisplays = (await Vue.axios.post(`/devicemonitor/getLedReport`)).data
    },
    calculateWidthPanels (ledDisplay) {
      return ledDisplay.width / ledDisplay.LedPitch.resolutionX
    },
    calculateHeightPanels (ledDisplay) {
      return ledDisplay.height / ledDisplay.LedPitch.resolutionY
    },
    calculateWidthmm (ledDisplay) {
      return this.calculateWidthPanels(ledDisplay) * ledDisplay.LedPitch.width
    },
    calculateHeightmm (ledDisplay) {
      return this.calculateHeightPanels(ledDisplay) * ledDisplay.LedPitch.height
    },
    calculateAreasqm (ledDisplay) {
      return this.calculateWidthmm(ledDisplay) * this.calculateHeightmm(ledDisplay) / (1000 * 1000)
    },
    recLookup (obj, path) {
      const parts = path.split('.')
      if (parts.length === 1) {
        return obj[parts[0]]
      }
      return this.recLookup(obj[parts[0]], parts.slice(1).join('.'))
    }
  },
  computed: {
    report () {
      return this.searchIsActive ? this.filteredDisplays : this.ledDisplays
    },
    filteredDisplays () {
      let filteredLedDisplays = JSON.parse(JSON.stringify(this.ledDisplays))
      for (const key of Object.keys(this.search)) {
        if (this.search[key].length > 0) {
          filteredLedDisplays = filteredLedDisplays.filter(d => this.recLookup(d, key).toLowerCase().indexOf(this.search[key].toLowerCase()) > -1)
        }
      }
      return filteredLedDisplays
    },
    searchIsActive () {
      for (const key of Object.keys(this.search)) {
        if (this.search[key].length > 0) return true
      }
      return false
    },
    getExcelHeader () {
      return `Led screens`
    },
    excelReport () {
      const ledscreens = []
      for (const ledscreen of JSON.parse(JSON.stringify(this.report))) {
        ledscreen['Width mm'] = this.calculateWidthmm(ledscreen)
        ledscreen['Height mm'] = this.calculateHeightmm(ledscreen)
        ledscreen['Number of panels in width'] = this.calculateWidthPanels(ledscreen)
        ledscreen['Number of panels in height'] = this.calculateHeightPanels(ledscreen)
        ledscreen['Area m²'] = this.calculateAreasqm(ledscreen)
        ledscreen.Device = ledscreen.Device.name
        ledscreen['Led pitch type'] = ledscreen.LedPitch.name
        delete ledscreen.led
        delete ledscreen.createdAt
        delete ledscreen.updatedAt
        delete ledscreen.LedPitch
        delete ledscreen.id
        ledscreens.push(ledscreen)
      }
      return ledscreens
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  border-bottom: $--border-light;
  &.header {
    color: $--color-text-secondary;
    border-bottom: 2px solid $--color-primary;
    // display: flex;
    // align-items: center;
    // justify-content: left;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
  .cell {
    flex: 1;
    &.header {
      display: flex;
      flex-direction: column;
      .input {
        margin-right: 20px;
        width: 90%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/LedReport.vue